export default __webpack_public_path__ + "static/media/Mac_Miler_Faces-0.25ETHM.dc7b7ae4.mp4";